(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["floating-contact-controls"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialiseFloatingCall = () => {
    const floatingCall = document.querySelector('.el-floating-call');
    if (!floatingCall) return;

    const mainCall = document.querySelector('.el-info-tile--call');
    if (!mainCall) {
      floatingCall.classList.remove('el-floating-call--waiting');
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      floatingCall.classList.toggle('el-floating-call--waiting', entry.isIntersecting);
    }, { threshold: 0.15 });

    observer.observe(mainCall);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseFloatingCall, { once: true });
  } else {
    initialiseFloatingCall();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
